function setupRActionFax() {
  ractionSetup($('#rfax'));
  $('#rfax form').submit(function () {
    $('#rfax button').prop('disabled', true);
    $('#rfax .fa-spinner').show();
    $.post($(this).attr('action'), $(this).serialize()).done(function (data) {
      nextAction();
    }).fail(function (jqXHR) {
      $('#rfax').replaceWith(jqXHR.responseText);
    });
    return false;
  });
}

function setupNamesFromCheckboxesFax(label) {
  window.namesFromCheckboxes = function(names, checkboxes) {
    if (checkboxes.length > 0) {
      $(names).parent().show();
      $(names).text($.map(checkboxes, function (e) {
        return $(e).parent().text().replace(/ \(.+\)/, '');
      }).join(", ").replace(/,\s([^,]+)$/, label));
    } else {
      $(names).parent().hide();
    }
  }
}

function bindLabelClickListener() {
  $('.label').click(function () {
    if ($('input', this).prop('checked')) {
      $('input', this).prop('checked', false);
      $(this).removeClass('label-primary');
    } else {
      $('input', this).prop('checked', true);
      $(this).addClass('label-primary');
    }
    namesFromCheckboxes($('#primaries-names'), $('#primaries-checkboxes input:checked'));
    namesFromCheckboxes($('#secondaries-names'), $('#secondaries-checkboxes input:checked'));
  });

  namesFromCheckboxes($('#primaries-names'), $('#primaries-checkboxes input:checked'));
  namesFromCheckboxes($('#secondaries-names'), $('#secondaries-checkboxes input:checked'));
}


/*** EXPORTS FROM exports-loader ***/
exports["setupRActionFax"] = (setupRActionFax);
exports["setupNamesFromCheckboxesFax"] = (setupNamesFromCheckboxesFax);
exports["bindLabelClickListener"] = (bindLabelClickListener);